import * as styles from './styles';

const DetailPanel = () => {
  return <div css={[styles.status, styles.statusFocused]}>상세보기</div>;
};

export default DetailPanel;
